import { RouteLocationNormalized } from 'vue-router'
import partnerCustomerTabs from '~/data/page-tabs/customer-portal.json'
import clientPageTabs from '~/data/page-tabs/customer.json'
import partnerPortalTabs from '~/data/page-tabs/partner-portal.json'
import pageTabs from '~/data/page-tabs/trucker.json'

const pages = {
  'trucker-id-quote': pageTabs.quote,
  'trucker-id-driver': pageTabs.driver,
  'trucker-id-vehicle': pageTabs.vehicle,
  'trucker-id-cost': pageTabs.cost,
  'trucker-id-report': pageTabs.report,
  'trucker-id-company-global-settings': pageTabs.company['global-settings'],
  'trucker-id-company-user-group': pageTabs.company['user-group'],
  'pp-id-company-user-group': partnerPortalTabs.company['user-group'],
  'pp-id-company-gps-settings': partnerPortalTabs.company['user-group'],
  'pp-id-company-global-settings': partnerPortalTabs.company['global-settings'],
  'admincp-business': pageTabs.systemBusiness,
  'admincp-settings': pageTabs.system.settings,
  'admincp-node': pageTabs.systemNode,
  'trucker-admin-id-business': pageTabs.admincpBusiness,
  'trucker-admin-id-node': pageTabs.admincpNode,
  'c-id-company-user-group': clientPageTabs.company['user-group'],
  'pc-id-company-user-group': partnerCustomerTabs.company['user-group'],
  'trucker-id-company-integration': pageTabs.company.integration,
  'trucker-id-marketplace': pageTabs.marketplace
} as { [key: string]: any }

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  if (!to?.name) {
    return
  }

  Object.keys(pages).forEach((key) => {
    if (String(to.name).includes(key)) {
      to.meta.pageTabs = pages[key]
    }
  })
})
